/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_Cat_2Inputs */

const en_mk_context_cat_2 = /** @type {(inputs: Mk_Context_Cat_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tone & Style`)
};

const id_mk_context_cat_2 = /** @type {(inputs: Mk_Context_Cat_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tone & Gaya`)
};

/**
* | output |
* | --- |
* | "Tone & Style" |
*
* @param {Mk_Context_Cat_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_cat_2 = /** @type {((inputs?: Mk_Context_Cat_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_Cat_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_cat_2(inputs)
	return en_mk_context_cat_2(inputs)
});